// base component
import { GlobalSearchComponent } from './global-search.component';
import { GlobalSearchModalComponent } from './global-search-modal.component';

const GlobalSearchModule = angular
  .module('topbroker.globalSearchModule', [])
  .component('globalSearch', GlobalSearchComponent)
  .component('globalSearchModal', GlobalSearchModalComponent)
  .name;

export default GlobalSearchModule;